import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import MediaService, { fallbackToLargestFile } from '../utils/DeviationMediaService';
import { BackgroundType, BackgroundImageDisplayMode } from './types';
import { gradientToClassName } from './utils';
import { styleFromWidthHeight } from '../DeviationViews/_helpers';
import { useDeviationMatureFilter } from '../utils/hooks/useDeviationMatureFilter';
import s from './Background.scss';
const Background = ({ className, contentClassName, backgroundClassName, children, onClick, variant = 'custombox', backgroundType, color, gradient, pattern, imageDisplayMode, imageTint, imageDeviation, imageUrl, width, height, style, noPadding, template: passedTemplate })=>{
    const { showBlocked } = useDeviationMatureFilter(imageDeviation);
    const backgroundClassNames = [];
    const sizeStyles = styleFromWidthHeight({
        width,
        height
    });
    const styles = {};
    switch(backgroundType){
        case BackgroundType.SOLID:
            // if the user has chosen a background color, use that.
            // If not, default to theme-based colors instead
            if (color) {
                styles.backgroundImage = `linear-gradient(${color}, ${color})`;
            } else {
                // we'll use a global css class that can be picked up by
                // shared's DaEditorWrapper custombox.scss
                backgroundClassNames.push(s['theme-based'], 'custombox_using_theme_defaults');
            }
            break;
        case BackgroundType.GRADIENT:
            backgroundClassNames.push(s['gradient'], gradientToClassName(gradient));
            break;
        case BackgroundType.PATTERN:
            backgroundClassNames.push(s['pattern']);
            styles.backgroundImage = `url(${pattern})`;
            break;
        case BackgroundType.IMAGE:
            backgroundClassNames.push(s['image']);
            // If we've got an `imageUrl`, the user used a template with a custombox or this is a profile skin.
            // We'll make this the priority.
            if (imageUrl) {
                // Note, our profile skin code is a bit wacky, so this might not actually be a URL. It could be a linear gradient.
                // We need to detect that before wrapping `imageUrl` in `url()`.
                styles.backgroundImage = imageUrl.startsWith('linear-gradient(') ? imageUrl : `url("${imageUrl}")`;
            } else {
                const file = width && height ? MediaService.getSmallestThumbThatFullyCovers(imageDeviation, width, height, fallbackToLargestFile) : MediaService.getLargestFullview(imageDeviation);
                if (file) {
                    styles.backgroundImage = `url("${file.src}")`;
                }
            }
            if (imageTint) {
                styles.backgroundImage = `linear-gradient(${imageTint}, ${imageTint}), ${styles.backgroundImage}`;
            }
            if (showBlocked) {
                backgroundClassNames.push(s['mature-blur']);
            }
            switch(imageDisplayMode){
                case BackgroundImageDisplayMode.CONTAIN:
                    backgroundClassNames.push(s['display-mode-contain']);
                    break;
                case BackgroundImageDisplayMode.TILE:
                    backgroundClassNames.push(s['display-mode-repeat']);
                    break;
                case BackgroundImageDisplayMode.COVER:
                default:
                    backgroundClassNames.push(s['display-mode-cover']);
            }
            break;
        default:
            // This is all custombox template code. When the user first selects a template, we
            // don't have the `imageUrl` we reference above. So we rely on this component's consumer
            // passing in a template.
            if (!passedTemplate) {
                break;
            }
            backgroundClassNames.push(s['image']);
            if (passedTemplate.backgroundImage) {
                styles.backgroundImage = `url("${passedTemplate.backgroundImage}")`;
            }
            if (imageTint) {
                styles.backgroundImage = `linear-gradient(${imageTint}, ${imageTint}), ${styles.backgroundImage}`;
            }
            switch(imageDisplayMode){
                case BackgroundImageDisplayMode.CONTAIN:
                    backgroundClassNames.push(s['display-mode-contain']);
                    break;
                case BackgroundImageDisplayMode.TILE:
                    backgroundClassNames.push(s['display-mode-repeat']);
                    break;
                case BackgroundImageDisplayMode.COVER:
                default:
                    backgroundClassNames.push(s['display-mode-cover']);
            }
            break;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[`variant-${variant}`], noPadding && s['no-padding'], ...backgroundClassNames, className),
        onClick: onClick,
        style: _object_spread({}, sizeStyles, style)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['background'], backgroundClassName),
        style: styles
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content'], contentClassName)
    }, children));
};
Background.displayName = 'Background';
export default Background;

//# sourceMappingURL=Background.js.map